module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Direction/images/direction-icon-D-doubled.7e2c7657.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Direction/images/direction-icon-D-doubled.png
// module id = 2516
// module chunks = 11